<template>
    <div>
        <!--面包屑-->
        <breadcrumb-link :title="getTitle"></breadcrumb-link>
        <!--内容区域-->
        <div>
            <el-button type="info" class="floatClass" plain size="small" @click="goBack" v-if="getDisabled">返回</el-button>
            <el-form :model="dataList" ref="dataList" label-width="130px" :disabled="getDisabled" :rules="rules">
                <div class="edit-title">基础信息</div>
                <el-form-item label="逻辑库db名称：" prop="name">
                    <el-input v-model="dataList.name" placeholder="名称不能超过50个字符" style="width: 800px;"></el-input>
                </el-form-item>
                <el-form-item label="逻辑库db类型: " prop="dbTypeId">
                    <el-select placeholder="请选择：" v-model="dataList.dbTypeId">
                        <el-option v-for="item in dbTypeList" :key="item.id" :label="item.name" :value="item.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="逻辑库描述: " prop="description">
                    <el-input v-model="dataList.description" placeholder="请输入description" style="width: 800px;"></el-input>
                </el-form-item>
                <div class="centerClass">
                    <el-button type="primary" @click="submitForm('dataList')" v-if="type != 'details'">保存
                    </el-button>
                    <el-button type="info" plain @click="goBack" v-if="!getDisabled">返回</el-button>
                </div>
                <!--schema配置-->
                <logic-form-table v-if="$route.query.id"></logic-form-table>
                <!--记录信息-->
                <history-record :historyTitle="historyTitle" :historyList="historyList" v-if="getDisabled" />
            </el-form>
        </div>
    </div>
</template>

<script>
import logicFormTable from "./componet/logicFormTable";
import BreadcrumbLink from "../../components/breadcrumbLink";
import util from "@/utils/util";
import HistoryRecord from "../../components/common/historyRecord";
import DialogTips from "../../components/dialogTips";
import {
    getLogicalDetail,
    addOrEditLogical
} from "@/apis/pipelineService/logicalDb";
import { mapState, mapActions } from "vuex";
export default {
    components: {
        DialogTips,
        HistoryRecord,
        BreadcrumbLink,
        logicFormTable
    },
    data() {
        return {
            type: "", // 跳转页面获取标题
            dataList: {
                name: "", // 物理库名称
                dbTypeId: "", // 数据库db类型
                description: "" // 逻辑库描述
            },
            historyTitle: "记录信息", // 记录信息标题
            historyList: [
                {
                    label: "创建人：",
                    value: ""
                },
                {
                    label: "创建时间：",
                    value: ""
                },
                {
                    label: "最后修改人：",
                    value: ""
                },
                {
                    label: "最后修改时间：",
                    value: ""
                }
            ], // 记录信息信息内容
            id: this.$route.query.id,
            rules: {
                name: [
                    {
                        required: true,
                        message: "请输入逻辑库db名称",
                        trigger: "blur"
                    },
                    {
                        min: 1,
                        max: 50,
                        message: "名称不能超过50个字符",
                        trigger: "blur"
                    }
                ],
                dbTypeId: [
                    {
                        required: true,
                        message: "请选择逻辑库db类型",
                        trigger: "change"
                    }
                ],
                description: [
                    {
                        required: true,
                        message: "请输入description",
                        trigger: "blur"
                    }
                ]
            }
        };
    },
    computed: {
        getDisabled() {
            return {
                add: false,
                edit: false,
                details: true
            }[this.type];
        },
        getTitle() {
            return {
                add: "新增逻辑库",
                edit: "修改逻辑库",
                details: "逻辑库详情"
            }[this.type];
        },
        ...mapState({
            dbTypeList: state => state.dbTypeList,
            logicalList: state => state.logicalList
        })
    },
    mounted() {
        this.type = this.$route.query.type;
        if (this.type != "add") {
            this.getDetails();
        }
        this.getDbTypeList();
    },
    methods: {
        ...mapActions([
            "getDbTypeList", // 获取数据库db类型
            "getLogicalListFu" // 获取逻辑库列表
        ]),
        // 返回上一层
        goBack() {
            this.$router.push({
                path: '/logicManagement'
            })
        },
        //列表时间格式化
        dateFormat(timestamp) {
            if (timestamp) {
                return util.timestampToTime13(timestamp);
            }
            return "--";
        },
        // 详情
        async getDetails() {
            let params = {
                id: this.id
            };
            try {
                const data = await getLogicalDetail(params);
                if (data.code == 0 && data.data) {
                    this.dataList = data.data;
                    this.historyList = [
                        {
                            label: "创建人：",
                            value: data.data.creatorName
                        },
                        {
                            label: "创建时间：",
                            value: this.dateFormat(data.data.createTime)
                        },
                        {
                            label: "最后修改人：",
                            value: data.data.updatorName
                        },
                        {
                            label: "最后修改时间：",
                            value: this.dateFormat(data.data.updateTime)
                        }
                    ];
                }
            } catch (error) {}
        },
        // 提交表单
        submitForm(formName) {
            this.$refs[formName].validate(valid => {
                if (valid) {
                    this.pushForm();
                } else {
                    return false;
                }
            });
        },
        // 提交
        async pushForm() {
            let params = {
                id: this.$route.query.id,
                name: this.dataList.name,
                description: this.dataList.description,
                dbTypeId: this.dataList.dbTypeId
            };
            if (this.type == "add") {
                delete params.id;
            }
            try {
                const data = await addOrEditLogical(params);
                if (data.code == 0) {
                    this.$router.push({
                        path: "/logicManagementForm",
                        query: {
                            type: "edit",
                            id: data.data.id || this.$route.query.id
                        }
                    });
                    this.type = 'edit'
                    this.$message.success(data.message);
                } else {
                    this.$message.error(data.message);
                }
            } catch (error) {}
        }
    }
};
</script>

<style scoped lang="scss">
.flexInline {
    display: flex;
}
.info {
    width: 100%;
    margin: 0 auto;
    background: #f8f8f8;
    border-radius: 10px;
    padding: 20px;
    margin-bottom: 20px;
}
.centerClass {
    text-align: center;
    margin: 0 auto;
    margin-top: 20px;
    .el-button {
        margin: 0 20px;
    }
}
.floatClass {
    float: right;
}
</style>
